<template>
  <div>
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <ErrorMessage v-if="errors.load" :error="errors.load" class="mt-2" />

    <Loader v-if="loading" />
    <div v-else-if="data.exam.id">
      <div class="relative py-16 bg-white overflow-hidden">
        <div class="relative px-4 sm:px-6 lg:px-8">
          <div class="text-lg max-w-prose mx-auto">
            <h1>
              <span
                class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
                >{{ data.exam.name }}
              </span>
            </h1>
            <h3
              class="mt-8 block text-xl text-center leading-8 font-bold tracking-tight text-gray-900 sm:text-2xl"
            >
              Текст вопроса
            </h3>
          </div>
          <div
            v-html="data.exam.text"
            class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto"
          ></div>
          <ErrorMessage v-if="errors.any" :error="errors.any" class="mt-2" />
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import ErrorMessage from "../components/ErrorMessage.vue";
//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "", validation: "" },
      title: "Просмотр вопроса",
      bcrumbs: [],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },

    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/exams/" + this.$route.params.id + "/show"
        );
        this.data = response.data;
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.load = e.response.data.error;
        } else if (e.response.status == 401) {
          this.errors.load = e.response.data.error;
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },
  },
  components: {
    Loader,
    PageTitle,
    BreadCrumbs,
    ErrorMessage,
  },
};
</script>